import { generateUtilityClasses } from '@mui/material';

const COMPONENT_NAME = 'DataGridCustom';

export const intakeDataGridCustomClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['error', 'rowError']),
};
